export function ImpersonationBanner() {
  const superToken = localStorage.getItem("fidalis_super_token");
  if (!superToken) return null;
  const cabName = localStorage.getItem("fidalis_imp_cabinet") || "un cabinet";
  const exit = () => {
    localStorage.setItem("fidalis_token", superToken);
    localStorage.removeItem("fidalis_super_token");
    localStorage.removeItem("fidalis_imp_cabinet");
    window.location.href = "/app/admin";
  };
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-2 bg-amber-500 text-black text-sm font-medium" data-testid="impersonation-banner">
      <span>Mode super admin — vous consultez « {cabName} »</span>
      <button onClick={exit} data-testid="impersonation-exit" className="underline font-semibold hover:opacity-80">Quitter</button>
    </div>
  );
}
